import { Box, Divider, Stack } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import OverallSkillRating from '../components/OverallSkillRating';
import InfoCircle from '../components/InfoCircle';

function SkillsInfo({ skillRating, location }) {
  const { formatMessage } = useLocalization();

  return (
    <Box sx={{ pt: 1, pb: 0.5 }}>
      <Stack direction="row">
        <OverallSkillRating value={skillRating} />
        <Box>
          <Divider orientation="vertical" sx={{ mx: 2 }} />
        </Box>
        <Stack direction="row">
          <InfoCircle
            label={formatMessage({
              id: 'LEGEND_SERVICES_BRAND',
              defaultMessage: 'Services Brand',
            })}
            value={location?.skills?.servicesBrand}
          />
          <InfoCircle
            label={formatMessage({
              id: 'LEGEND_SERVICES_INDUSTRY',
              defaultMessage: 'Services Industry',
            })}
            value={location?.skills?.servicesIndustry}
          />
          <InfoCircle
            label={formatMessage({
              id: 'LEGEND_SERVICES_PRODUCT_LINE',
              defaultMessage: 'Services Product Line',
            })}
            value={location?.skills?.servicesProductLine}
          />
          <InfoCircle
            label={formatMessage({
              id: 'LEGEND_WITHIN_TRAVEL_DISTANCE',
              defaultMessage: 'Within Travel Distance',
            })}
            value={location?.skills?.withinTravelDistance}
          />
        </Stack>
      </Stack>
    </Box>
  );
}

export default SkillsInfo;
